import { render, staticRenderFns } from "./pjck.vue?vue&type=template&id=5702177b&scoped=true&"
import script from "./pjck.vue?vue&type=script&lang=js&"
export * from "./pjck.vue?vue&type=script&lang=js&"
import style0 from "./pjck.vue?vue&type=style&index=0&id=5702177b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5702177b",
  null
  
)

export default component.exports